// extracted by mini-css-extract-plugin
module.exports = {"header":"header___1CBRy","header__logo":"header__logo___bdmTg","header__content":"header__content___36Ju3","header__content__text":"header__content__text___2y8YZ","header__content__button":"header__content__button___36SmZ"};
    if(module.hot) {
      // 1677682834793
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  